import { formatDateFromISO } from '@practium/shared';
import { DetailModal, BrainIcon } from '@practium/ui';
import CalendarToday from '@mui/icons-material/CalendarToday';
import Spa from '@mui/icons-material/Spa';
import Check from '@mui/icons-material/Check';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { CATEGORY_LABELS } from '../../../types/productRequest.types';
import styles from './UpdateStatusModal.module.css';
import { RequestProduct } from '@practium/features/products/types';

interface UpdateStatusModalProps {
	request: RequestProduct;
	onClose: () => void;
	onSave: (status: 'APPROVED' | 'REJECTED') => void;
}

export const UpdateStatusModal = ({ request, onClose, onSave }: UpdateStatusModalProps) => {
	const iconColor = 'var(--primary)';

	const footer =
		request.status === 'PENDING' ? (
			<div className={styles.btnWrapper}>
				<button
					type="button"
					className={styles.rejectBtn}
					onClick={() => onSave('REJECTED')}
				>
					<CloseOutlined className={styles.btnIcon} />
					Rejeitar
				</button>
				<button
					type="button"
					className={styles.approveBtn}
					onClick={() => onSave('APPROVED')}
				>
					<Check className={styles.btnIcon} />
					Aprovar
				</button>
			</div>
		) : undefined;

	return (
		<DetailModal
			title={`Solicitação de Produto - ${request.userName}`}
			metaItems={[
				{
					icon: <CalendarToday className={styles.metaIcon} style={{ color: iconColor }} />,
					text: formatDateFromISO(request.createdAt),
				},
				{
					icon: <Spa className={styles.metaIcon} style={{ color: iconColor }} />,
					text: 'Solicitação de Produto',
				},
				{
					icon: <BrainIcon color={iconColor} />,
					text: `Por ${request.userName}`,
				},
			]}
			sections={[
				{
					title: 'Informações Gerais',
					fields: [
						{ label: 'Nome', value: request.name, span: 'full' },
						{ label: 'Fabricante', value: request.manufacturer },
						{ label: 'Categoria', value: CATEGORY_LABELS[request.category] },
						{ label: 'Solicitante', value: request.userName },
						{ label: 'Data', value: formatDateFromISO(request.createdAt) },
						{ label: 'Observações', value: request.note ?? '—', span: 'full' },
					],
				},
			]}
			footer={footer}
			onClose={onClose}
		/>
	);
};
